import { useState } from 'react';
import { BiConversation } from 'react-icons/bi';

import { ArrowCircleBackground } from '../../../../assets/images/icons/arrow-circle-background';
import {
  StyledButton,
  StyledInput,
  StyledSelect,
  StyledTextarea,
  StyledUploadFile,
} from '../../../../components';
import { AdminTitle } from '../../components';
import { ButtonContainer, Container } from './styles';

export const Contato = () => {
  const [assunto, setAssunto] = useState('');

  return (
    <>
      <AdminTitle title="Contato" icon={<BiConversation />} />

      <Container>
        <div className="lineContainer">
          <div>
            <StyledSelect
              placeholder="Selecione o assunto"
              options={[{ value: 'teste', id: 1 }]}
              setValue={setAssunto}
            />

            <StyledInput placeholder="Digite o seu telefone com DDD" />

            <StyledUploadFile />
          </div>

          <StyledTextarea placeholder="Mensagem" />
        </div>
      </Container>

      <ButtonContainer>
        <StyledButton
          text="Enviar"
          icon={<ArrowCircleBackground />}
          iconPosition="right"
        />
      </ButtonContainer>
    </>
  );
};
